import { useMemo } from 'react';
import { SearchTable } from './SearchTable';
import {
  dummyConfig,
  getBrandPortalTableColumns
} from './columns/BrandPortalTableColumns';
import { EventSearchDocument } from 'types/Search';
import { UnionCustomAttributeProps } from 'components/common/Portals/CustomAttributes/types';
import { useSearchTableColumnManagement } from './hooks/useSearchTableColumnManagement';
import { useBrandPortalEventKey } from 'hooks/useBrandPortalEventKey';
import { columnConfiguration } from 'components/constants/Constants';
import { MRT_Row } from 'material-react-table';
import { SearchViewPropsExtended } from './types';
import { ProductType } from 'types/Products';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { SegmentTag } from 'types/global';
type SearchTableProps<T extends object> = {
  customAttributesDefinitions: {
    data?: UnionCustomAttributeProps[];
    loading: boolean;
    error: boolean;
  };
} & SearchViewPropsExtended<T>;

export const BrandPortalTable: React.FC<
  SearchTableProps<EventSearchDocument>
> = props => {
  const { searchTableColumnsConfiguration } = useFlags();

  const columns = useMemo(
    () =>
      getBrandPortalTableColumns(
        props.customAttributesDefinitions.data,
        props.searchResults.search?.segment ?? SegmentTag.PERSONALCARE,
        props.searchResults.search?.target ?? ProductType.INGREDIENTS,
        searchTableColumnsConfiguration
      ),
    [
      props.customAttributesDefinitions.data,
      props.searchResults.search?.segment,
      props.searchResults.search?.target,
      searchTableColumnsConfiguration
    ]
  );
  const eventKey = useBrandPortalEventKey();
  const columnConfigColumns = columnConfiguration
    .find(el => el.eventKey === eventKey)
    //TODO: Once we remove the Feature flag we can get rid of this logo and change the keys in the env directly
    ?.fields.flatMap(el =>
      searchTableColumnsConfiguration && el.id === 'attributes'
        ? [
            { ...el, id: 'inci' },
            { ...el, id: 'applications' }
          ]
        : [el]
    )
    .filter(el => searchTableColumnsConfiguration || el.id !== 'attributes');

  const { columnOrder, setColumnOrder, columnVisibility, setColumnVisibility } =
    useSearchTableColumnManagement(eventKey, columnConfigColumns, columns);

  const generateProductPageLink = (row: MRT_Row<EventSearchDocument>) => {
    if (!row.original.event?.event?.key) return '';
    return `/events/${row.original.event.event.key}/product/${row.original.old_key}`;
  };

  return (
    <SearchTable<EventSearchDocument>
      {...props}
      getRowId={row => row.id}
      columns={columns ?? dummyConfig}
      generateItemPageLink={generateProductPageLink}
      columnManagement={{
        columnOrder,
        setColumnOrder,
        columnVisibility,
        setColumnVisibility
      }}
    />
  );
};
